import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./ShortTextInput.module.css";
import { HelperError, Label } from "./ShortTextInput";

function TextAreaInput({
  label,
  defaultValue,
  error,
  helperText,
  id,
  onChange,
  value,
  placeholder,
  fullWidth,
  labelColor,
  className,
  style,
  disabled,
  rows = 4,
  required, // show required field indicator if true
}) {
  return (
    <div
      style={{
        marginBottom: "16px",
        height: "100%",
        width: fullWidth ? "100%" : "auto",
      }}
    >
      {/* Label */}
      {label && <Label id={id} required={required} label={label}  />}

      {/* Textarea */}
      <textarea
        id={id}
        value={value}
        defaultValue={defaultValue}
        onChange={onChange}
        placeholder={placeholder}
        className={classNames(styles.inputBase, {
          [styles.inputError]: error,
          [styles.inputDisabled]: disabled,
        }, className)}
        style={style}
        aria-describedby={`${id}-helper-text`}
        disabled={disabled}
        rows={rows}
      />

      {/* Helper Text */}
      {(helperText || error) && <HelperError id={id} error={error} helperText={helperText}/>}
    </div>
  );
}

// Default Props
TextAreaInput.defaultProps = {
  label: "",
  defaultValue: "",
  error: "",
  helperText: "",
  id: "custom-textarea",
  onChange: () => {},
  value: "",
  placeholder: "",
  fullWidth: false,
  labelColor: "",
  rows: 4,
};

// Prop Types
TextAreaInput.propTypes = {
  label: PropTypes.string,
  defaultValue: PropTypes.string,
  error: PropTypes.string,
  helperText: PropTypes.string,
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  fullWidth: PropTypes.bool,
  labelColor: PropTypes.string,
  rows: PropTypes.number,
};

export default TextAreaInput;
